import NLP from "../NLP";
import { HabitType } from "tsproto/aware_proto/proto/Modules";
const Habits = {
    [HabitType.UnknownHabitType]: {
        habitType: HabitType.UnknownHabitType,
        match: (doc) => {
            return [false];
        },
        fnTool: undefined,
    },
    [HabitType.PlaceTransitDuration]: {
        habitType: HabitType.PlaceTransitDuration,
        match: (doc) => {
            const expr = "how long * (go|get) to [.*]";
            const match = doc.match(expr);
            if (match.text()) {
                const group0Text = match.groups("0").text();
                return [true, group0Text];
            }
            return [false];
        },
        fnTool: {
            name: "HabitType.PlaceTransitDuration",
            description: "Returns how long it takes for a user to transit to a specified location",
            args: { placeName: { type: "STRING", description: "location name" } },
            prefilter: (input) => { return NLP.doc(input).has("how long"); }
        },
    },
    [HabitType.PlaceStayDuration]: {
        habitType: HabitType.PlaceStayDuration,
        match: (doc) => {
            const expr = "how long * (stay|spend) at [.*]";
            const match = doc.match(expr);
            if (match.text()) {
                const group0Text = match.groups("0").text();
                return [true, group0Text];
            }
            return [false];
        },
        fnTool: {
            name: "HabitType.PlaceStayDuration",
            description: "Returns how long a user typically stays at a specified location",
            args: { placeName: { type: "STRING", description: "location name" } },
            prefilter: (input) => { return NLP.doc(input).has("how long"); }
        },
    },
    [HabitType.PlaceMostRecent]: {
        habitType: HabitType.PlaceMostRecent,
        match: (doc) => {
            const expr = "when * (last|recent|recently) * (visit|visited|to|at) [.*]";
            const match = doc.match(expr);
            if (match.text()) {
                const group0Text = match.groups("0").text();
                return [true, group0Text];
            }
            return [false];
        },
        fnTool: {
            name: "HabitType.PlaceMostRecent",
            description: "Returns the most recent time that a user visited a specified location",
            args: { placeName: { type: "STRING", description: "location name" } },
            prefilter: (input) => { return NLP.doc(input).has("when"); }
        },
    },
    [HabitType.PlaceTimeOfDay]: {
        habitType: HabitType.PlaceTimeOfDay,
        match: (doc) => {
            const exprs = [
                "(when|what time|what times) * (usually|typically|generally|tend) * (visit|visited|to|at) [.*]",
                "(when|what time|what times) of day * (visit|visited|to|at) [.*]",
            ];
            for (const expr of exprs) {
                const match = doc.match(expr);
                if (match.text()) {
                    const group0Text = match.groups("0").text();
                    return [true, group0Text];
                }
            }
            return [false];
        },
        fnTool: {
            name: "HabitType.PlaceTimeOfDay",
            description: "Returns typical times of day that a user spends at a specified location",
            args: { placeName: { type: "STRING", description: "location name" } },
            prefilter: (input) => { return NLP.doc(input).has("(when|what time|what times)"); }
        },
    },
    [HabitType.PlaceFrequency]: {
        habitType: HabitType.PlaceFrequency,
        match: (doc) => {
            const expr = "how often * (visit|to|at) [.*]";
            const match = doc.match(expr);
            if (match.text()) {
                const group0Text = match.groups("0").text();
                return [true, group0Text];
            }
            return [false];
        },
        fnTool: {
            name: "HabitType.PlaceFrequency",
            description: "Returns how frequently a user tends to visit a specified location",
            args: { placeName: { type: "STRING", description: "location name" } },
            prefilter: (input) => { return NLP.doc(input).has("how often"); }
        },
    },
    [HabitType.ActivityDuration]: {
        habitType: HabitType.ActivityDuration,
        match: (doc) => {
            return [false];
        },
        fnTool: undefined,
    },
    [HabitType.ActivityMostRecent]: {
        habitType: HabitType.ActivityMostRecent,
        match: (doc) => {
            return [false];
        },
        fnTool: undefined,
    },
    [HabitType.ActivityTimeOfDay]: {
        habitType: HabitType.ActivityTimeOfDay,
        match: (doc) => {
            return [false];
        },
        fnTool: undefined,
    },
    [HabitType.ActivityFrequency]: {
        habitType: HabitType.ActivityFrequency,
        match: (doc) => {
            return [false];
        },
        fnTool: undefined,
    },
    [HabitType.PersonMostRecent]: {
        habitType: HabitType.PersonMostRecent,
        match: (doc) => {
            const expr = "when * (last|recent|recently) * (see|saw|meet|met) [.*]";
            const match = doc.match(expr);
            if (match.text()) {
                const group0Text = match.groups("0").text();
                return [true, group0Text];
            }
            return [false];
        },
        fnTool: {
            name: "HabitType.PersonMostRecent",
            description: "Returns the most recent time that a user saw or met with a person",
            args: { personName: { type: "STRING", description: "person name" } },
            prefilter: (input) => { return NLP.doc(input).has("when"); }
        },
    },
};
class Habit {
    habitType;
    match;
    fnTool;
}
export { Habits, Habit };
